import React from 'react';
import { translate } from '../../../../utils/translate';
import { CreateBanner } from './CreateBanner';

const IMAGE = {
    MD: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/36c3116c3b06b9a8d0445a77063e5b09-1732794430714/sign-business-profile-banner-md.png',
    LG: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/36c3116c3b06b9a8d0445a77063e5b09-1732794430717/sign-business-profile-banner-lg.png',
};

export const ProfileBanner = () => (
    <CreateBanner imageSrcMd={IMAGE.MD} imageSrcLg={IMAGE.LG} title={translate('image_banner.profile_setup_title')} />
);
